export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },

        home: {
            h1: "MetaMask Tiền điện tử",
            h1B: "Ngân hàng MetaMask Tiền điện tử",
            h1C: "Ví DeFi Tiền điện tử",
            h1D: "Ngân hàng Coinbase Tiền điện tử",
            h1E: "Ngân hàng tiết kiệm MetaMask",
            h1F: "Betterment",
            h2: "Mời bạn bè",
            h3: "Liên kết tài khoản rút tiền",
            h4: "Tham gia tiết kiệm",
            h4B: "Nạp tiền điện tử",
            h4C: "Nạp tiền kỹ thuật số",
            h5: "Đầu tư chọn lọc",
            h5B: "Giao dịch hợp đồng nhanh",
            h5c: "Nạp vào",
            h6: "Hồ bơi người dùng",
            h7: "Tài khoản USDT",
            h8: "Tổng sản lượng",
            h9: "Nút hợp lệ",
            h10: "Người tham gia",
            h11: "Thu nhập",
            h12: "Lịch sử thu nhập",
            h13: "Địa chỉ",
            h14: "Số hiệu",
            h15: "Câu hỏi thường gặp",
            h16: "Làm thế nào để tham gia?",
            h17: "Kính gửi người dùng, nếu bạn muốn tham gia tiết kiệm ví USDT, bạn cần tuân thủ các quy tắc của nền tảng, thực hiện nghiêm quyết định của nền tảng và chấp nhận giám sát của bộ phận rủi ro. Bạn sẽ tự động được cấp quyền gửi tiền. Chào mừng tham gia, cảm ơn.",
            h17B: "Kính gửi người dùng, nếu bạn muốn tham gia tiết kiệm ví USDT, bạn cần tuân thủ các quy tắc của nền tảng, thực hiện nghiêm quyết định của nền tảng và chấp nhận giám sát của bộ phận rủi ro. Bạn sẽ tự động được cấp quyền gửi tiền. Chào mừng tham gia, cảm ơn.",
            h18: "Làm thế nào để rút tiền?",
            h19: "Thu nhập hàng ngày sẽ tự động được ghi vào số dư tài khoản. Khi rút USDT thành công, số tiền sẽ tự động thêm vào tài khoản ví USDT của bạn. Nếu muốn rút Yên Nhật, vui lòng liên hệ trung tâm hỗ trợ khách hàng. Cảm ơn sự tham gia và ủng hộ của bạn.",
            h19B: "Thu nhập hàng ngày sẽ tự động được ghi vào số dư tài khoản. Khi rút USDT thành công, số tiền sẽ tự động thêm vào tài khoản ví USDT của bạn. Nếu muốn sử dụng phương thức rút khác, vui lòng liên hệ hỗ trợ trực tuyến!",
            h20: "Thu nhập được tính như thế nào?",
            h21B: "Mua theo chu kỳ, lợi nhuận khác nhau theo cấp VIP\nVIP1  100u~5000u, lãi suất: 1.8%\nVIP2  5000u~20000u, lãi suất: 2.6%\nVIP3  20000u~50000u, lãi suất: 3.5%\nVIP4  50000u~80000u, lãi suất: 4.7%\nVIP5  80000u~120000u, lãi suất: 5.3%\nVIP6  120000u~160000u, lãi suất: 6.2%\nVIP7  160000u~200000u, lãi suất: 7.3%\nVIP8  Trên 200000u, lãi suất: 8%\n\n",
            h21: "Sau khi tham gia thành công, hợp đồng tiết kiệm sẽ bắt đầu tính lợi nhuận.",
            h22: "Thu nhập từ tiết kiệm đến từ đâu?",
            h23: "Sau khi người dùng tham gia tiết kiệm, hợp đồng tiết kiệm có hiệu lực. Lãi suất được tính hai lần mỗi ngày vào 00:00 và 12:00. Sau khi hợp đồng có hiệu lực, quỹ sẽ được quản lý, nền tảng chịu trách nhiệm về an toàn tài chính. Để bảo đảm an toàn tài khoản, vui lòng tuân thủ quy định của nền tảng. Nếu có vấn đề, liên hệ hỗ trợ trực tuyến.",
            h23B: "Sau khi người dùng tham gia tiết kiệm, hợp đồng tiết kiệm có hiệu lực. Lãi suất được tính hai lần mỗi ngày vào 00:00 và 12:00. Sau khi hợp đồng có hiệu lực, quỹ sẽ được quản lý, nền tảng chịu trách nhiệm về an toàn tài chính. Để bảo đảm an toàn tài khoản, vui lòng tuân thủ quy định của nền tảng. Nếu có vấn đề, liên hệ hỗ trợ trực tuyến.",
            h24: "Tiền thưởng là bao nhiêu?",
            h25: "Bạn có thể chia sẻ nền tảng của tôi với bạn bè. Khi bạn bè tham gia, bạn sẽ nhận được 20% tiền thưởng từ lần nạp đầu tiên và 10% hoa hồng vĩnh viễn từ thu nhập của họ. Liên kết chia sẻ nằm ở góc trên bên phải của trang chủ.",
            h25B: "Bạn có thể chia sẻ nền tảng với bạn bè. Khi bạn bè tham gia, bạn sẽ nhận được 20% tiền thưởng từ lần nạp đầu tiên và 10% hoa hồng vĩnh viễn từ thu nhập của họ. Liên kết chia sẻ nằm ở góc trên bên phải của trang chủ.",
            h26: "Số dư khả dụng",
            h27: "Số tiền nạp",
        
            h88: "Bối cảnh nền tảng",
            h89: "Betterment\nThành lập: 2008\nTrụ sở: New York, Mỹ\nVị trí: Robo-Advisor & FinTech, cung cấp quản lý danh mục đầu tư tự động và quản lý tiền mặt\nCơ quan quản lý: Dưới sự giám sát của SEC, là thành viên FINRA\nQuy mô khách hàng: Quản lý tài sản trên 40 tỷ USD\nKhách hàng: Hơn 800.000 cá nhân và doanh nghiệp",
            h90: "Ưu điểm nền tảng",
            h91: "✔️ Robo-Advisor sớm nhất tại Mỹ, nhiều kinh nghiệm\n✔️ Danh mục dựa trên Lý thuyết Phân bổ Tài sản Hiện đại (MPT), giảm rủi ro\n✔️ Cung cấp tối ưu hóa thuế\n✔️ Tài khoản tiền mặt lãi suất cao, thanh khoản tốt\n✔️ Hoàn toàn số hóa, giao diện đơn giản",
            h92: "Đối tượng phù hợp",
            h93: "★ Người muốn đầu tư ổn định dài hạn, không muốn thao tác thường xuyên\n★ Nhà đầu tư trẻ cần quản lý tự động, tiết kiệm thời gian\n★ Người kết hợp đầu tư + tiết kiệm lãi cao + tài khoản hưu trí\n★ Người muốn tham gia thị trường tài chính với chi phí thấp",
        
            h28: "Thu nhập hôm nay",
            h29: "Tổng thu nhập",
            h30: "Rút tiền",
            h31: "Lịch sử",
            h32: "Số dư khả dụng",
            h33: "Số tiền rút",
            h34: "Vui lòng nhập số tiền rút",
            h35: "Tất cả",
            h36: "Rút tiền",
            h37: "Câu hỏi thường gặp",
            h38: "Có báo cáo kiểm toán bảo mật",
            h39: "Đối tác",
            h40: "Đối tác kinh doanh của chúng tôi",
            h41: "Hiển thị số thẻ ngân hàng",
            h42: "Trang trước",
            h43: "Trang sau",
            h44: "Đây là trang đầu tiên",
            h45: "Vui lòng nhập số tiền rút",
            h46: "Số dư không đủ",
            h47: "Đây là trang cuối cùng",
            h48: "Thu nhập",
            h49: "Chi tiêu",
            h50: "Thao tác quá nhanh, vui lòng thử lại sau.",
            h51: "Báo cáo kiểm toán",
            h52: "Tiết kiệm bằng coin",
            h521: "Tiết kiệm bằng tiền gửi",
            h53: "Giao dịch đơn hàng",
            h54: "Thưởng đăng ký",
            h55: "Thưởng mời bạn",
            h56: "Rút tiền",
            h57: "Nạp tiền",
            h58: "Tiền gửi",
            h59: "Rút tiền",
            h591: "Nạp tiền thành công",
            h592: "Nạp tiền thất bại",
            h593: "Số dư không đủ",
            h60: "Tặng USDT qua chuyển tiền tiền điện tử",
            h61: "Cảm ơn bạn đã ủng hộ Ngân hàng MetaMask. Để tiết kiệm dễ dàng hơn, hãy sử dụng tiền điện tử (USDT ETH BTC) chuyển khoản để nhận thưởng tiết kiệm. Tiết kiệm trên 1000 USDT nhận 30 USDT, trên 5000 USDT nhận 200 USDT, trên 10000 USDT nhận 5% mỗi lần nạp. (Rút bằng ví tiền điện tử cũng được hưởng ưu đãi này)",
            h61B: "Cảm ơn bạn đã ủng hộ Ngân hàng Coinbase. Chuyển khoản bằng tiền điện tử (USDT ETH BTC) để nhận thưởng tiết kiệm. Tiết kiệm trên 1000 USDT nhận 30 USDT, trên 5000 USDT nhận 200 USDT, trên 10000 USDT nhận 5% mỗi lần nạp.",
            h61C: "Cảm ơn bạn đã ủng hộ Ngân hàng MetaMask. Chuyển khoản bằng tiền điện tử (USDT ETH BTC) để nhận thưởng tiết kiệm. Tiết kiệm trên 1000 USDT nhận 30 USDT, trên 5000 USDT nhận 200 USDT, trên 10000 USDT nhận 5% mỗi lần nạp.",
            h61D: "Cảm ơn bạn đã ủng hộ Betterment. Chuyển khoản bằng tiền điện tử (USDT ETH BTC) để nhận thưởng tiết kiệm. Tiết kiệm trên 1000 USDT nhận 30 USDT, trên 5000 USDT nhận 200 USDT, trên 10000 USDT nhận 5% mỗi lần nạp.",
            h62: "Số tiền rút của bạn là {amount}, phí là {fee}%!",
            h63: "Xác nhận",
            h99: "Sắp mở",
        },
        bankcard: {
            b1: "Tài khoản ngân hàng",
            b2: "Tên tổ chức tài chính",
            b3: "Vui lòng nhập tên tổ chức tài chính",
            b4: "Tên chi nhánh",
            b5: "Vui lòng nhập tên chi nhánh",
            b6: "Số chi nhánh",
            b7: "Vui lòng nhập số chi nhánh",
            b8: "Số tài khoản (thường)",
            b9: "Vui lòng nhập số tài khoản",
            b10: "Tên giả",
            b11: "Vui lòng nhập tên người dùng",
            b12: "Chủ tài khoản",
            b13: "Vui lòng nhập tên chủ tài khoản",
            b14: "Liên kết",
            b15: "Địa chỉ tiền điện tử",
            b16: "Vui lòng nhập địa chỉ tiền điện tử",
        },
        usdt: {
            u1: "Đơn hàng của tôi",
            u2: "Nạp vào",
            u3: "Vui lòng chọn thời hạn hợp đồng:",
            u4: "Giá mua:",
            u5: "Vui lòng nhập số tiền nạp",
            u6: "Tăng mua",
            u7: "Giảm mua",
            u8: "Thao tác thành công",
            u9: "Ít nhất một chút"
        },
        order: {
            o0: "Đơn hàng của tôi",
            o1: "Mã đơn hàng",
            o2: "Loại đơn hàng",
            o3: "Số tiền mua",
            o4: "Số tiền bán",
            o5: "Số tiền thanh toán",
            o6: "Thời hạn hợp đồng",
            o7: "Trạng thái đơn hàng",
            o8: "Trạng thái thanh toán",
            o9: "Thời gian thanh toán",
            o10: "Thời gian đặt hàng",
            o11: "Tăng mua",
            o12: "Giảm mua",
            o13: "Đã bán",
            o14: "Lợi nhuận",
            o15: "Thua lỗ",
            o16: "Đã thanh toán",
            o17: "Điểm hòa vốn"
        },
        recharge: {
            r1: "Số tiền nạp",
            r2: "Số tiền nạp",
            r3: "Loại nạp tiền",
            r4: "Vui lòng chọn",
            r5: "Địa chỉ nạp tiền",
            r6: "Mã giao dịch chuyển khoản",
            r7: "Đã chuyển",
            r8: "Đang xét duyệt",
            r9: "Nhập không đúng",
            r10: "Vui lòng chọn phương thức thanh toán",
            r11: "Số tiền nạp tối thiểu",
            r12: "Số tiền nạp tối đa",
            r13: "Vui lòng nhập số tiền",
            r14: "Tải lên ảnh thanh toán",
            r15: "Vui lòng tải ảnh thanh toán lên",
            r16: "Gửi thành công",
            r17: "Hủy",
            r18: "Xác nhận",
        },
        rechargeDetails: {
            r1: "Lịch sử nạp tiền",
            r2: "Số tiền nạp",
            r3: "Đang xét duyệt",
            r4: "Nạp thành công",
            r5: "Nạp thất bại"
        },
		cert: {
		    c1: "Xác minh danh tính",
		    c2: "Tên thật",
		    c21: "Vui lòng nhập tên thật của bạn",
		    c3: "Loại xác minh",
		    c31: "Chứng minh nhân dân",
		    c32: "Hộ chiếu",
		    c33: "Giấy phép lái xe",
		    c10: "Nhập loại xác minh",
		    c4: "Mặt trước của giấy tờ",
		    c41: "Vui lòng tải lên mặt trước của giấy tờ",
		    c5: "Mặt sau của giấy tờ",
		    c51: "Vui lòng tải lên mặt sau của giấy tờ",
		    c6: "Gửi",
		    c7: "Gửi thành công, đang chờ xem xét...",
		    c8: "Đã xác minh thành công",
		    c9: "Xác minh danh tính không thành công, vui lòng tải lại giấy tờ",
		    c11: "Đang xem xét",
		    "传入字段不完整": "Trường nhập không đầy đủ",
		    "已认证过": "Đã được xác minh",
		    "审核中": "Đang xem xét"
		}
		 }